import { memo, useContext, useEffect } from "react";
import StaticPage from "app/pages/StaticPage/StaticPage";
import { useParams } from "react-router-dom";
import { useFetchStaticPage } from "app/pages/StaticPage/useFetchStaticPage";
import AppGlobalsContext from "app/AppGlobalsContext";
import { sendTagOnStaticPage } from "app/utils/analytics";

const StaticPageContainer = () => {
	const { slug } = useParams();
	const { resolution } = useContext(AppGlobalsContext);

	useEffect(() => {
		sendTagOnStaticPage(slug);
	}, [slug]);

	const { blocks = [], title, titleBlock = {} } = useFetchStaticPage(slug);

	return (
		<StaticPage blocks={blocks} titleBlock={titleBlock} title={title} resolution={resolution} />
	);
};

export default memo(StaticPageContainer);
